import React from "react";
import PropTypes from "prop-types";
import LoaderSpinner from "../../common/Loader";
import PnLTable from "./PnLTable";
import { formatMoney } from "./pnlReportUtils";

export const PnLKpis = ({ totals }) => (
  <div className="pnl-kpis">
    <div className="pnl-kpi">
      <div className="pnl-kpi-label">Gross amount</div>
      <div className="pnl-kpi-value">{formatMoney(totals.gross)}</div>
    </div>
    <div className="pnl-kpi">
      <div className="pnl-kpi-label">Net amount</div>
      <div className={`pnl-kpi-value ${totals.net < 0 ? "pnl-neg" : "pnl-pos"}`}>{formatMoney(totals.net)}</div>
    </div>
  </div>
);

PnLKpis.propTypes = {
  totals: PropTypes.shape({ gross: PropTypes.number, net: PropTypes.number }).isRequired,
};

export const PnLLegend = ({ allCollapsed, disabled, onToggleAll }) => (
  <div className="pnl-legend">
    <span><span className="pnl-chip final">Final</span> Locked, won&apos;t change on refresh</span>
    <span><span className="pnl-chip prov">Provisional</span> Month ended, not saved yet</span>
    <span><span className="pnl-chip prov">Awaiting returns</span> Shipping labels stay open until returns are closed</span>
    <span><span className="pnl-chip live">In progress</span> Current month</span>
    <span className="pnl-spacer" />
    <button type="button" className="pnl-link-button" onClick={onToggleAll} disabled={disabled}>
      {allCollapsed ? "Expand all months" : "Collapse all months"}
    </button>
  </div>
);

PnLLegend.propTypes = {
  allCollapsed: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onToggleAll: PropTypes.func.isRequired,
};

export const PnLResults = ({ loading, loadError, groups, totals, collapsedKeys, onToggleMonth, onSelectRow }) => (
  <div className="pnl-table-card">
    {loading && <div className="pnl-loading"><LoaderSpinner /></div>}
    {!loading && loadError && <div className="pnl-empty" role="alert">{loadError}</div>}
    {!loading && !loadError && groups.length === 0 && (
      <div className="pnl-empty">No records found for the selected filters.</div>
    )}
    {groups.length > 0 && (
      <PnLTable
        groups={groups}
        totals={totals}
        collapsedKeys={collapsedKeys}
        onToggleMonth={onToggleMonth}
        onSelectRow={onSelectRow}
      />
    )}
  </div>
);

PnLResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadError: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  totals: PropTypes.object.isRequired,
  collapsedKeys: PropTypes.instanceOf(Set).isRequired,
  onToggleMonth: PropTypes.func.isRequired,
  onSelectRow: PropTypes.func.isRequired,
};
